module.exports = __webpack_public_path__ + "static/media/gallery-2.29ddf84c.jpg";